module.exports = __webpack_public_path__ + "static/media/tolppakeppien-kuuppien-kaivuu.ab55b8ce.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./media/photos/tolppakeppien-kuuppien-kaivuu.jpg
 ** module id = 424
 ** module chunks = 0
 **/